import React, {useState} from 'react';
import theme from 'styles/theme';

export default function Button(props) {
    const {
        label,
        action,
        style,
        hoverStyle,
        focusStyle,
        type = 'button',
        buttonRef,
        variant = 'primary',
    } = props;

    let {children, aria} = props;
    children = children || label;

    if (aria) {
        // filter out any properties of aria that aren't related to accessibility
        aria = Object.keys(aria).reduce((filteredAria, attr) => {
            if (attr == "role" || attr.startsWith("aria-")) {
                filteredAria[attr] = aria[attr];
            }
            return filteredAria;
        }, {});
    }

    const [hovered, setHovered] = useState(false);
    const [focussed, setFocussed] = useState(false);

    const variantStyles = theme.button?.[variant] || {};
    const baseStyle = style || variantStyles.base || {};
    const hover = hoverStyle || variantStyles.hover || {};
    const focus = focusStyle || variantStyles.focus || {};

    return (
        <button
            title={label}
            type={type}
            onClick={e => action(e)}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            onFocus={() => setFocussed(true)}
            onBlur={() => setFocussed(false)}
            ref={buttonRef}
            style={{
                ...baseStyle,
                ...(hovered ? hover : {}),
                ...(focussed ? focus : {})
            }}
            {...(aria || {})}
        >
            {children}
        </button>
    );
}